import { useEffect, useState } from "react";
import ProgressBar from "../../../components/atoms/progress-bar";
import api from "../../../services/api";
import styled from "styled-components";

import { toast } from "react-toastify";

import { CircularProgress } from "@mui/material";

/* ── Styled Components para Capacity Bar ── */

const CapacityWrapper = styled.div`
  margin-bottom: 0;
`;

const CapacityHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
`;

const CapacityLabel = styled.span`
  font-size: 0.73rem;
  color: var(--gray-400);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const CapacityCount = styled.span<{ level: string }>`
  font-size: 0.73rem;
  font-weight: 800;
  color: var(--navy, #1a2252);
`;

const CapacityTrack = styled.div`
  height: 6px;
  background: var(--gray-100, #eef0f5);
  border-radius: var(--radius-full, 9999px);
  overflow: hidden;
`;

const CapacityFill = styled.div<{ percent: number; level: string }>`
  height: 100%;
  width: ${({ percent }) => percent}%;
  border-radius: var(--radius-full, 9999px);
  transition: width 1s cubic-bezier(0.4, 0, 0.2, 1);
  background: ${({ level }) =>
    level === "low" ? "var(--success-500, #0ea572)" :
    level === "mid" ? "var(--warning-500, #f59e0b)" :
    "var(--red, #e4202c)"
  };
`;

/* ── Component ── */

type Props = {
  title: string;
  maxInscricoes: number;
  ajusteQuantidadeDeInscricoes: number;
  IsQuantidadeInscricaoEstatica: boolean;
  quantidadeInscricaoEstatica: number;
  variant?: "bar" | "capacity";
};

const TournamentProgress = ({
  title,
  maxInscricoes,
  ajusteQuantidadeDeInscricoes,
  IsQuantidadeInscricaoEstatica,
  quantidadeInscricaoEstatica,
  variant = "bar",
}: Props) => {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    const fetchPaid = async () => {
      try {
        if (IsQuantidadeInscricaoEstatica) return setCount(quantidadeInscricaoEstatica);

        const { data } = await api.get("/tournaments/enrollments/count-paid");

        const normalize = (str: string) =>
          str.normalize("NFKD").replace(/\s+/g, " ").trim().toUpperCase();

        const resp = data.find(
          (torn: any) => normalize(torn.tournament) === normalize(title)
        );

        if (resp) {
          setCount(resp.inscricoes + ajusteQuantidadeDeInscricoes);
        } else {
          setCount(0 + ajusteQuantidadeDeInscricoes);
        }
      } catch (error) {
        console.error(error);
        toast.error("Não foi possível carregar os dados do torneio.");
      }
    };

    fetchPaid();
  }, [title]);

  if (count === null) return <CircularProgress size={18} />;

  /* ── Capacity bar variant (design system) ── */
  if (variant === "capacity") {
    const percent = Math.min(Math.round((count / maxInscricoes) * 100), 100);
    const level = percent >= 80 ? "high" : percent >= 50 ? "mid" : "low";

    return (
      <CapacityWrapper>
        <CapacityHeader>
          <CapacityLabel>Vagas</CapacityLabel>
          <CapacityCount level={level}>
            {count}/{maxInscricoes} ({percent}%)
          </CapacityCount>
        </CapacityHeader>
        <CapacityTrack>
          <CapacityFill percent={percent} level={level} />
        </CapacityTrack>
      </CapacityWrapper>
    );
  }

  /* ── Default: simple progress bar ── */
  return <ProgressBar total={maxInscricoes} progress={count} height={20} />;
};

export default TournamentProgress;
